import Envelope from '@/icons/envelope.vue';
import Lock from '@/icons/lock.vue';
import User from '@/icons/user.vue';
import XIcon from '@/icons/x.vue';
import GoogleIcon from '@/icons/google.vue';
import AppleIcon from '@/icons/apple.vue';
import ProfileCard from '@/icons/ProfileCard.vue';
import HuggingFace from '@/icons/hugging-face.vue';
import GithubIcon from '@/icons/github.vue';
import WebsiteIcon from '@/icons/website.vue';
export function useIcons() {
  return {
    Envelope,
    Lock,
    User,
    XIcon,
    GoogleIcon,
    AppleIcon,
    ProfileCard,
    HuggingFace,
    GithubIcon,
    WebsiteIcon
  };
}